
// region JS Imports

// region External Modules
import $ from "jquery"
import serialize from "form-serialize"

import {
  EventEmitter,
} from "events"
// endregion External Modules

// region Private Modules
import I18n from "plugins/i18n-js"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"

import {
  unsubscribe,
} from "app/resources/building_followings/unsubscribe"

import {
  FollowTypes,
} from "app/resources/building_followings/subscribe"
// endregion Private Modules

// region Public Components
import Notifier from "app/notifier"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope: string

  backdrop: string

  main_content:           string
  confirm_cancel_content: string

  form: string

  back_button:    string
  confirm_button: string

  follow_buttons: string
}
interface InputSelector {
  scope?:              string

  backdrop?: string

  main_content?:           string
  confirm_cancel_content?: string

  form?: string

  back_button?:    string
  confirm_button?: string

  follow_buttons?: string
}

const default_selector = {
  scope: ".cell--buildings--follow-type-select-dropdown",

  backdrop: ".cell--buildings--follow-type-select-dropdown-backdrop",

  main_content:           ".cell--buildings--follow-type-select-dropdown--main-content",
  confirm_cancel_content: ".cell--buildings--follow-type-select-dropdown--confirm-cancel-follow-content",

  form: ".cell--buildings--follow-type-select-dropdown--form",

  back_button:    ".cell--buildings--follow-type-select-dropdown--action-bar-back-button",
  confirm_button: ".cell--buildings--follow-type-select-dropdown--action-bar-confirm-button",

  follow_buttons: ".cell--buildings--following--button",
}

const $body = $("body")

interface Input {
  user_authentication_handle: string,

  building_id: string | number,

  follow_type: FollowTypes,
}

export class DropdownContent extends EventEmitter {
  protected selector: Selector

  protected $scope: JQuery
  protected $main: JQuery

  protected $backdrop: JQuery

  protected $main_content: JQuery
  protected $confirm_cancel_content: JQuery

  protected $form: JQuery

  protected $back_button: JQuery
  protected $confirm_button: JQuery

  protected $follow_buttons: JQuery

  private subscribe_input: Input

  constructor(subscribe_input: Input, selector?: InputSelector){
    super()

    this.selector = Object.assign({}, default_selector, selector)
    this.$scope = $(this.selector.scope)
    this.$main = $(this.selector.scope)

    this.$backdrop = $(this.selector.backdrop)

    this.$main_content = this.$scope.find(this.selector.main_content)
    this.$confirm_cancel_content = this.$scope.find(this.selector.confirm_cancel_content)

    this.$form = this.$scope.find(this.selector.form)

    this.$back_button = this.$scope.find(this.selector.back_button)
    this.$confirm_button = this.$scope.find(this.selector.confirm_button)

    this.$follow_buttons = $(this.selector.follow_buttons)

    this.subscribe_input = subscribe_input

    this.created()
    this.bind_action()
  }

  protected created() {
    this.$scope.addClass("js-spacious-initialized")

    setTimeout(()=>{
      this.$main.addClass("active")
      this.$backdrop.addClass("fixed")
    }, 100)

    $("html").css({"overflow": "hidden", "height": "100vh"})
    // https://stackoverflow.com/a/44853591, fix safari "overflow: hidden" not working issue
    $body.css({"overflow": "hidden", "touch-action": "none"})
  }

  protected bind_action() {
    // region on touching behavior

    let original_client_y = 0
    let new_client_y = 0
    let sort_menu_init_height = 0

    this.$main.on("touchstart", (e) => {
      // https://stackoverflow.com/questions/41993176/determine-touch-position-on-tablets-with-javascript
      original_client_y = e.originalEvent?.touches[0].clientY as number

      sort_menu_init_height = parseFloat(this.$main.css("height"))
    })

    this.$main.on("touchmove", (e) => {
      // https://stackoverflow.com/questions/41993176/determine-touch-position-on-tablets-with-javascript
      new_client_y = e.originalEvent?.touches[0].clientY as number

      const new_sort_menu_height = sort_menu_init_height - (new_client_y - original_client_y)

      this.$main.css("height", Math.min(sort_menu_init_height, new_sort_menu_height))
    })

    this.$main.on("touchend",() => {
      const new_sort_menu_height = parseFloat(this.$main.css("height"))

      if ( sort_menu_init_height - new_sort_menu_height > 10 && Math.abs(new_client_y - original_client_y) > 20) {
        this.on_close()
      }
    })

    // endregion on touching behavior

    this.$backdrop.on("click", () => {
      if ( this.$main.hasClass("active") ) {
        this.on_close()
      }
    })

    let checked_count = this.$form.find("input[type=\"checkbox\"]:checked").length

    this.$scope.find(".slide-toggle").on("click", (e) => {
      const $checkbox = $(e.target).siblings("input[type='checkbox']")
      const isChecked = $checkbox.prop("checked")

      // Prevent toggling the last checked option (require confirmation)
      if (checked_count === 1 && isChecked) {
        this.switch_display_content(this.$main_content, this.$confirm_cancel_content)
        return
      }

      // Toggle the checked state
      $checkbox.prop("checked", !isChecked)

      // Update the checked_count based on the new state
      checked_count += (!isChecked ? 1 : -1)

      this.update_follow_record()
    })

    this.$back_button.on("click", () => {
      this.switch_display_content(this.$main_content, this.$confirm_cancel_content)
    })

    this.$confirm_button.on("click", () => {
      const building_name = this.$main.data("building-name")
      unsubscribe(this.subscribe_input).then(() => {
        const alert_message = I18n.t(
          "apps_spacious_website_partials.buildings.confirm_cancel_follow_modal.content.success_unfollow_message",
          {
            building: building_name || "",
          },
        )

        Notifier.showSpaciousBlackAlert(alert_message, 5000)
        this.$follow_buttons.filter(`[data-building-id="${this.subscribe_input.building_id}"]`).removeClass("following")
        this.on_close()
      })
    })
  }

  public on_close() {
    this.$main.removeClass("active")

    this.$backdrop.removeClass("fixed")
    this.$main.removeAttr("data-slideout-ignore")

    $("html").css({"overflow": "", "height": ""})
    $body.css({"overflow": "", "touch-action": ""})

    setTimeout(()=>{
      this.$main.remove()
      this.$backdrop.remove()
    },300)

    this.emit("dropdown_closed")
  }

  protected switch_display_content($main_content: JQuery, $confirm_cancel_content: JQuery) {
    $main_content.toggle()
    $confirm_cancel_content.toggle()
  }

  protected update_follow_record()  {
    const form_data = serialize(this.$form[0] as HTMLFormElement, { hash: true }) || {}

    const form_url_path = this.$form.attr("action") || ""
    q_ajax_3({
      url:      form_url_path,
      method:   "POST",
      dataType: "html",

      // Sending JSON to server
      contentType:  "application/json; charset=utf-8",
      data:         JSON.stringify(form_data),
    })
  }

}

const Factory = {
  _instance: null as null | DropdownContent,
  instance(subscribe_input: Input){
    if (this._instance != null){
      return this._instance
    }
    this._instance = this.create(subscribe_input)
    return this._instance
  },
  create(subscribe_input: Input){
    return new DropdownContent(subscribe_input)
  },
  destroy() {
    this._instance = null
  },
}

export {
  Factory,
}
